import { isThisISOWeek } from "date-fns"
import _ from 'lodash'

export class Inventory {
    constructor(inventory) {
        this.inventory = inventory
    }

    _safe(property, fn) {
        if(this.inventory && this.inventory[property]) {
            const prop = this.inventory[property]
            return fn(prop)
        } else {
            return false
        }
    }

    at(version) {
        return this._safe('info', info => info.at == version)
    }

    versions() {
        return this._safe('versions', versions => versions) || []
    }

    latest() {
        const versions = this.versions()
        return versions.length === 0 ? undefined : versions[versions.length - 1]
    }

    isLatest() {
        const lastOne = this.latest()
        return !lastOne || lastOne == this._safe('info', info => info.at)
    }

    places() {
        return this.placesMatching(place => !place.deleted)
    }

    placesMatching(filter) {
        const any = () => true
        return this._safe('places', places => places.filter(filter || any)) || []
    }

    placeGroups() {
        const byText = op => op.text
        const groups = this
        .places()
        .filter(place => place.group)
        .map(place => {
            return {
                id    : place.id,
                text  : place.group,
            }
        })
        return _.sortBy(_.uniqBy(groups, byText), byText)
    }

    activities() {
        return this._safe('activities', activities => activities.filter(p => !p.deleted)) || []
    }

    projectionGiven(activity) {
        return this._safe('projections', projections => projections.find(p => p.activity === activity.id))
    }

    _issuesGiven(scope) {
        const filter = iss => iss.scope.find(s => s === scope)
        return this._safe('issues', issues => issues.filter(filter)) || []
    }

    placeIssues(place) {
        if(place) {
            return this._issuesGiven("PLACE").filter(iss => iss.place && iss.place.id === place.id)
        } else {
            return this._issuesGiven("PLACES")
        }
    }

    activityIssues(activity) {
        if(activity) {
            return this._issuesGiven("ACTIVITY").filter(iss => iss.activity && iss.activity.id === activity.id)
        } else {
            return this._issuesGiven("ACTIVITIES")
        }
    }

    activityById(id) {
        return this.activities().find(it => it.id === id)
    }
    
    activitiesGiven(field) {
        const filterProjection = p => {
            const forus = !p.deleted && p.fields.filter(f => f.field === field.id && f.place === field.place)
            return forus && forus.length > 0
        }
        return this._safe('projections', projections => {
            return projections.filter(filterProjection).map(p => this.activityById(p.activity))
        })
    }
}

export class Activity {
    
    constructor(inventory, activity) {
        this.inventory = inventory
        this.activity = activity
    }

    _safe(property, fn, dftl) {
        if(this.activity && this.activity[property]) {
            const prop = this.activity[property]
            return fn ? fn(prop) : prop
        } else {
            return dftl
        }
    }

    profiles() {
        return this._safe('profiles', null, [])
    }

    splitIssues() {
        const issues = this.inventory.activityIssues(this.activity)
        return {
            profile    : issues.filter(iss => iss.scope.find(scope => scope == "PROFILE")),
            projection : issues.filter(iss => iss.scope.find(scope => scope == "PROJECTION"))
        }
    }

}